<div class="modal-content">
  <!-- Modal Header -->
  <div class="modal-header">
    Change Language Order
    <i class="material-icons" data-bs-dismiss="modal" (click)='close()'>close</i>
  </div>
  <!-- Modal body -->
  <div class="modal-body">
    <ul cdkDropList (cdkDropListDropped)="onItemDrop($event)" class="reorder-component">
      @for (playbookLanguage of playbookLanguages; track playbookLanguage; let i = $index) {
        <li cdkDrag
          [ngClass]="pinnedPlaybookLanguage === playbookLanguage.id ?'not_allowed':''"
          [cdkDragDisabled]="pinnedPlaybookLanguage === playbookLanguage.id">
          <div class="cntr" [ngClass]="pinnedPlaybookLanguage === playbookLanguage.id ?'not_allowed':''">
            <label class="custom-checkbox custom__checkmark custom__checkmark-15" [ngClass]="pinnedPlaybookLanguage === playbookLanguage.id ?'not_allowed':''">
              <input class="checkbox" type="checkbox" (change)="checkLength(i)" [checked]="playbookLanguage.isSelected"
                [disabled]="pinnedPlaybookLanguage === playbookLanguage.id"
                [ngClass]="pinnedPlaybookLanguage === playbookLanguage.id ?'not_allowed':''">
              <span class="checkmark vPlaybookActiveToggle"></span>
            </label>
            <label class="lbl textEllipsis" (click)="checkLength(i)"
            [ngClass]="pinnedPlaybookLanguage === playbookLanguage.id ?'not_allowed':''">{{playbookLanguage.name}}</label>
          </div>
          <span class="reorder-ico"><i class="material-icons" style=" font-size: 24px;">open_with</i></span>
          @if (playbookLanguage.isSelected) {
            <span class="reorder-ico cursor-pointer" style="right: 35px;" (click)="pinLangauge(playbookLanguage.id)"
              >
              @if (!pinnedPlaybookLanguage) {
                <img src="../../../../assets/img/push_pin-dark.svg">
              }
              @if (pinnedPlaybookLanguage && pinnedPlaybookLanguage === playbookLanguage.id) {
                <img src="../../../../assets/img/push_pin-black.svg"
                  >
              }
            </span>
          }
        </li>
      }
    </ul>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn vPlaybookDefaultButton" data-bs-dismiss="modal" (click)='resetSelection()'>Show All Languages</button>
    <button type="button" class="btn vPlaybookDefaultButton" data-bs-dismiss="modal" (click)='close()'>Cancel</button>
    <button id="editImageModalSaveBtnId" class="btn btn__btn-default btn__orange mr-top-1"
    [ngClass]="{'custom-btn-disabled': !isAllowed}" [disabled]="!isAllowed" (click)="save()">Save</button>
  </div>
</div>
